(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.mobileSearchDetails = this.querySelector('.mobile-menu-top details-modal.header__search details');

      // ===== Lock page scroll when mobile search is open =====
      this.scrollYBeforeLock = 0;

      this.lockPageScroll = () => {
        this.scrollYBeforeLock = window.scrollY || document.documentElement.scrollTop || 0;
        document.documentElement.classList.add('search-lock');
        document.body.classList.add('search-lock');
        document.body.style.top = `-${this.scrollYBeforeLock}px`;
      };

      this.unlockPageScroll = () => {
        document.documentElement.classList.remove('search-lock');
        document.body.classList.remove('search-lock');
        const top = document.body.style.top;
        document.body.style.top = '';
        const y = top ? Math.abs(parseInt(top, 10)) : this.scrollYBeforeLock;
        window.scrollTo(0, y || 0);
      };

      // (опционально) пересчёт top для dropdown, если ты используешь переменную --mobile-ps-top
      this.updateMobilePsTop = () => {
        const form = this.querySelector('.mobile-menu-top details-modal.header__search .search-modal__content form.search');
        if (!form) return;
        const r = form.getBoundingClientRect();
        document.documentElement.style.setProperty('--mobile-ps-top', `${Math.round(r.bottom + 8)}px`);
      };

      if (this.mobileSearchDetails) {
        this.mobileSearchDetails.addEventListener('toggle', () => {
          if (this.mobileSearchDetails.open) {
            this.lockPageScroll();
            this.updateMobilePsTop();
            window.addEventListener('resize', this.updateMobilePsTop);
          } else {
            this.unlockPageScroll();
            window.removeEventListener('resize', this.updateMobilePsTop);
            document.documentElement.style.removeProperty('--mobile-ps-top');
          }
        });
      }

      

      if (this.mobileSearchDetails) {
        this.mobileSearchDetails.addEventListener('toggle', () => {
          if (this.mobileSearchDetails.open) {
            // держим хедер видимым и без трансформаций
            this.header.classList.remove('shopify-section-header-hidden');
            this.header.classList.add('shopify-section-header-sticky');
            this.header.style.transform = 'none';
          }
        });
      }

    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
